import React from "react";

const ArrowIcon = () => (
  <svg
    width="43"
    height="31"
    viewBox="0 0 43 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.75 14.2879H40.2398M40.2398 14.2879L23.9504 1.42773M40.2398 14.2879L23.9504 29.2501"
      stroke="white"
      strokeWidth="2.69249"
    />
  </svg>
);

export default ArrowIcon;